import { makeDownstreamApiCall } from "@payment-client/utils/Api";
import * as WalletApi from "@payment-client/interfaces/WalletApi";
import { ApiResponse } from "@payment-client/interfaces/Api";
import { DOWNSTREAM_ENDPOINTS, DOWNSTREAM_HOSTS } from "@payment-client/constants/Hosts";

export async function aPayValidateTransactionPublic(params: {
    [key: string]: unknown;
}): Promise<ApiResponse<WalletApi.APayValidateTransaction>> {
    const response = await makeDownstreamApiCall<ApiResponse<WalletApi.APayValidateTransaction>>({
        apiHost: DOWNSTREAM_HOSTS.PAYMENT_PRESENTATION_SERVICE_HOST,
        endpoint: DOWNSTREAM_ENDPOINTS.APAY_PUBLIC_VALIDATE_TRANSACTION,
        bodyParams: params,
        options: {
            method: "POST",
        },
    });

    return response;
}
